import { useParams, useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import SiteNavbar from '../../components/feature/SiteNavbar';
import FooterSection from '../home/components/FooterSection';
import AuthorHero from './components/AuthorHero';
import AuthorArticles from './components/AuthorArticles';
import { getAuthorById } from '../../mocks/authors';
import { blogPosts } from '../../mocks/blog';

export default function AutorPage() {
  const { slug } = useParams<{ slug: string }>();
  const navigate = useNavigate();

  const author = slug ? getAuthorById(slug) : undefined;
  const authorPosts = blogPosts.filter((p) => {
    if (!author) return false;
    return p.author === author.name;
  });

  useEffect(() => {
    if (!author) {
      navigate('/blog', { replace: true });
    }
  }, [author, navigate]);

  if (!author) return null;

  return (
    <div className="bg-zinc-950 min-h-screen">
      <SiteNavbar />
      <main>
        <AuthorHero author={author} articleCount={authorPosts.length} />
        <AuthorArticles posts={authorPosts} authorName={author.name} />
      </main>
      <FooterSection />
    </div>
  );
}
